import { render, staticRenderFns } from "./BarReservations.vue?vue&type=template&id=51a6a3a6&scoped=true"
import script from "./BarReservations.vue?vue&type=script&lang=js"
export * from "./BarReservations.vue?vue&type=script&lang=js"
import style0 from "./BarReservations.vue?vue&type=style&index=0&id=51a6a3a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a6a3a6",
  null
  
)

export default component.exports